import { Modal } from 'antd';
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface IMapExtendedViewModalProps {
  open: boolean;
  isMobile?: boolean | null;
  onClose: () => void;
  /** Handler `afterOpenChange`: ricalcola la size a fine animazione. */
  onOpenChange: (open: boolean) => void;
  /** Contenuto della modal: outlet del nodo-mappa + eventuali overlay. */
  children?: ReactNode;
}

/**
 * Modal a larghezza (quasi) piena che ospita la mappa in visualizzazione estesa.
 * Fa solo da contenitore: la mappa vi entra tramite `MapHostOutlet` (spostamento
 * del nodo stabile), non viene rimontata. `destroyOnClose` garantisce che alla
 * chiusura l'outlet della modal si smonti e il nodo torni allo slot inline.
 */
export function MapExtendedViewModal(props: IMapExtendedViewModalProps) {
  const { open, isMobile, onClose, onOpenChange, children } = props;
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      afterOpenChange={onOpenChange}
      footer={null}
      title={t('map-widget.extended-view.title', 'Mappa')}
      width={isMobile ? '100%' : 'calc(100vw - 32px)'}
      style={{ top: 16, maxWidth: '100vw', paddingBottom: 0 }}
      styles={{
        // La mappa è a filo su sx/dx/basso: niente padding sul content, il
        // padding resta solo sull'header; il body riempie l'altezza rimanente.
        content: {
          padding: 0,
          height: 'calc(100vh - 32px)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        },
        header: { padding: '16px 24px', marginBottom: 0 },
        body: { flex: 1, minHeight: 0, padding: 0 },
      }}
      destroyOnClose
    >
      <div style={{ position: 'relative', width: '100%', height: '100%' }}>
        {children}
      </div>
    </Modal>
  );
}
